import type { GeofenceValidationQuery, GeofenceValidationSummary, UUID } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class LegacyGeofenceRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public validate = (validationQueries: GeofenceValidationQuery[]): Promise<GeofenceValidationSummary> => {
    const requestData: IRequest = {
      endpoint: '/geofences/import-requisition/create',
      method: HttpMethod.POST,
      body: JSON.stringify(validationQueries),
    };
    return this.requester.request(requestData).then((response) => response.data);
  };

  public import = (importId: UUID): Promise<null> => {
    const requestData: IRequest = {
      endpoint: '/geofences/import-requisition/confirm',
      method: HttpMethod.POST,
      body: JSON.stringify({
        import_id: importId,
      }),
    };
    return this.requester.request(requestData).then(() => null);
  };
}

export default LegacyGeofenceRequester;
